import {
  type BucketLogData,
  bucketLog,
  formattingLogData,
} from '@bucketplace/bucket-log';
import { useEffect } from 'react';
import {
  type InViewHookResponse,
  useInView,
} from 'react-intersection-observer';

interface UseImpressionLogProps {
  logData?: BucketLogData;
  threshold?: number;
  disable?: boolean;
}

interface UseImpressionLog {
  ref: InViewHookResponse['ref'];
}

export function useImpressionLog({
  logData,
  threshold,
  disable,
}: UseImpressionLogProps): UseImpressionLog {
  const { ref, inView } = useInView({
    threshold,
    skip: disable,
    triggerOnce: true,
  });
  useEffect(() => {
    if (inView && !disable && !!logData) {
      bucketLog({
        category: 'impression',
        data: [
          {
            ...formattingLogData(logData),
            time: Date.now(),
          },
        ],
      });
    }
  }, [inView, disable, logData]);
  return {
    ref,
  };
}
